import { marsToBaidu, deepClone } from "../../utils";
import { HUB_ORDER_STATUS } from "../../const/hub-status";
import { convertHubOrder } from "./convert-hub-order";

export function handleHubOrder({ context, order, oldOrder }) {
  const MapService = context ? context.$MapService : null
  const { id: oldId, status: oldStatus } = deepClone(oldOrder || {}) ;

  // 更新orderInfo
  let orderInfo = deepClone(order || {})
  orderInfo = Object.assign({}, orderInfo, convertHubOrder(orderInfo, oldOrder));

  const {
    id,
    busLng,
    busLat,
    busLicense,
    busId,
    onStopLng,
    onStopLat,
    onStopName,
    onStopId,
    offStopLng,
    offStopLat,
    offStopName,
    offStopId,
    route,
    stopNavList,
    sureStatus,
    sureTime,
    onTime
  } = orderInfo || {};

  // 这里处理逻辑先保持与原模式一致，理论上枢纽站模式不使用这俩字段了
  const isArrive = sureStatus === 1 && sureTime > 0; // 司机是否到站
  const isTimeoutArrive = sureStatus === 1 && sureTime <= 0; // 司机是否超时到站

  // 更新orderInfo
  orderInfo = Object.assign({}, orderInfo, {
    isArrive,
    isTimeoutArrive,
  });

  if (oldId === id && oldStatus != status) {
    // 待接单->待出发
    if (oldStatus === HUB_ORDER_STATUS.HUB_PAYED && status === HUB_ORDER_STATUS.HUB_HAS_ACCEPT) {
      orderInfo.statusChangeText = "接单成功！请耐心等候";
      MapService && MapService.setMapFitViewModeC();
      MapService && MapService.setFitView();
    } else if (status === HUB_ORDER_STATUS.HUB_PASSENGER_GET_ON) {
      // 已上车
      orderInfo.statusChangeText = "您已上车！";
    } else {
      orderInfo.statusChangeText = "";
    }
  }

  // 地图显示车辆位置
  if (busLng && busLat && orderInfo.isBusVisible) {
    const { lng, lat } = marsToBaidu(busLng, busLat);
    const bus = {
      lng,
      lat,
      point: new BMapGL.Point(lng, lat),
      license: busLicense,
      id: busId,
      isArrive,
      isTimeoutArrive,
      onTime
    };
    MapService && MapService.setMapDataBusPos(bus);
  }

  // 地图显示上车点
  if (onStopLng && onStopLat && orderInfo.isOnStopVisible) {
    let { lng, lat } = marsToBaidu(onStopLng, onStopLat);
    let runningOnStop = {
      lng,
      lat,
      point: new BMapGL.Point(lng, lat),
      name: onStopName,
      id: onStopId,
    };
    MapService && MapService.setMapDataRunningOnStop(runningOnStop);
  } else {
    MapService && MapService.setMapDataRunningOnStop(null);
  }
  if (!orderInfo.isOnStopVisible) {
    MapService && MapService.removeOverlayRunningOnStopMarker();
  }

  // 地图显示下车点
  if (offStopLng && offStopLat) {
    let { lng, lat } = marsToBaidu(offStopLng, offStopLat);
    let runningOffStop = {
      lng,
      lat,
      point: new BMapGL.Point(lng, lat),
      name: offStopName,
      id: offStopId,
    };
    MapService && MapService.setMapDataRunningOffStop(runningOffStop);
  }

  // 地图显示路径规划
  if (route && orderInfo.isBusVisible) {
    MapService && MapService.setMapDataRunningRoute(route);
  } else {
    MapService && MapService.setMapDataRunningRoute(null);
  }

  // 地图显示途径站点
  if (stopNavList && stopNavList.length && orderInfo.isBusVisible) {
    const lastItem = stopNavList[stopNavList.length - 1]
    const has = lastItem && lastItem.stopId === offStopId
    const list = [...stopNavList]
    if (!has) {
      list.push({
        stopId: offStopId,
        lng: offStopLng,
        lat: offStopLat,
      })
    }
    MapService && MapService.setMapDataRunningNaviStop(list);
  } else {
    MapService && MapService.setMapDataRunningNaviStop(null);
  }
  console.log("解析后订单详情", orderInfo);
  return orderInfo;
}
